import { SyncState } from '@/interfaces/states/sync-state.interface';

export default {
  isActive: (state: SyncState): boolean => state.isActive,
  progress: (state: SyncState): number => state.progress,
  errors: (state: SyncState): Error[] => state.errors,
};
